import React from "react";
import {
  LandingView,
  NotFoundView,
  TermsView,
  LoginView,
  EcatlProfileView,
  ChrisProfileView,
  DocumentationView,
  ClientsView,
  AppsView
} from "../views";
import { Navigate, Routes, Route, Outlet } from "react-router-dom";
import { useAuth } from "providers/AuthContextProvider";
import MainLayout from "layouts/MainLayout";
import DashboardLayout from "layouts/DashboardLayout";

const ProtectedRoute = ({ allowedRoles, userRole }) => {
  // Si el rol del usuario está en la lista permitida, renderiza la ruta (Outlet)
  // De lo contrario, mándalo al home o a una página de "No autorizado"
  return allowedRoles.includes(userRole) 
    ? <Outlet /> 
    : <Navigate to="/home" replace />;
};

export default function Router() {
  const { user } = useAuth();

  const role = user?.role; // Asumiendo que el rol viene aquí

  // Definimos quiénes NO son viewers (ejemplo: admin y editor)
  const staffRoles = ['messiah','admin', 'editor'];

  return (
    <Routes>
      {/* Redirect root */}
      <Route element={<MainLayout />}>
        <Route path="/home" element={<LandingView />} />
        <Route path="/terms" element={<TermsView />} />
        <Route path="/documentation" element={<DocumentationView/>}/>
      </Route>
      
      <Route path="/dashboard" element={user ? <DashboardLayout/> : <Navigate to='/login' replace/>}>
        <Route element={<ProtectedRoute allowedRoles={staffRoles} userRole={role} />}>
          <Route path="clients">
            <Route index element={<ClientsView />} />
          </Route>
           <Route path="apps">
            <Route index element={<AppsView />} />
          </Route>
        </Route>
      </Route>
      
      <Route path="/israel" element={<EcatlProfileView />} />
      <Route path="/chris" element={<ChrisProfileView />} />
      <Route path="/login" element={ user ? <Navigate to="/dashboard" replace /> : <LoginView/>}/>

      <Route path="/" element={<Navigate to="/home" replace />} />
      {/* Explicit 404 page */}
      <Route path="/404" element={<NotFoundView />} />
      {/* Catch-all: must be last */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
